import { Model } from './model.class'
import { TTerraceWidth } from '../../utility/type/terraceCover.type'

/**
 * A class for model dari
 */
export abstract class Dari extends Model {
  /**
   * Returns number of windows
   * @param width Width of the terrace
   * @returns number of windows needed
   */
  public static windowsTop(width: TTerraceWidth): number {
    const number = this.windowsTopTotal(width)

    return number
  }

  /**
   * Method to calculate number of double bars for the windows
   * @returns Number of double bars
   */
  public static doubleBarsTop(windowsTotal: number): number {
    return windowsTotal - 1
  }

  /**
   * Helper method for dariWindows to calculate number of windows
   * @param width Width of the terrace
   * @returns
   */
  private static windowsTopTotal(width: TTerraceWidth): number {
    switch (true) {
      case width >= 300 && width < 400:
        return 3
      case width >= 400 && width < 500:
        return 6
      case width >= 500 && width < 600:
        return 6
      case width >= 600 && width < 700:
        return 8
      case width >= 700 && width < 800:
        return 8
      case width >= 800 && width < 900:
        return 11
      case width >= 900 && width < 1000:
        return 11
      case width >= 1000:
        return 14
      default:
        return 3
    }
  }
}
